// @ts-nocheck
import React from 'react'
import { colors } from '@lmc/common/constants'
import GPForm from '../GPForm'
import ImportantContactForm from '../ImportantContactForm'
import { ButtonOLD } from '@lmc/ui-kit'
import Glyph from '../../../../LEGACY/Glyph'
import ConfirmationDialog from '../../../../LEGACY/ConfirmationDialog'

export default class ResidentImportantContacts extends React.Component {
  state = {
    contactsCount: 0,
    contactToDelete: null,
    deleteDialogOpen: false,
  }

  componentDidMount() {
    this.setState({
      contactsCount: this.props.fields.importantContacts
        ? this.props.fields.importantContacts.length
        : 0,
    })
  }

  addContact = () => {
    this.setState((prevState) => ({
      contactsCount: prevState.contactsCount + 1,
    }))
  }

  closeDeleteDialog = () => {
    this.setState({
      contactToDelete: null,
      deleteDialogOpen: false,
    })
  }

  deleteContact = () => {
    this.props.onDelete({
      key: 'importantContacts',
      indexes: this.state.contactToDelete,
    })
    this.setState((prevState) => ({
      contactsCount: prevState.contactsCount - 1,
    }))
    this.closeDeleteDialog()
  }

  renderContacts = (count) => {
    const { fields, formId, style, family } = this.props
    return [...Array(count)].map((_e, index) => (
      <div key={index}>
        <ImportantContactForm
          contactsCount={count}
          fields={fields}
          formId={formId}
          index={index}
          family={family}
          onAdd={this.addContact}
          onDelete={() =>
            this.setState({
              contactToDelete: index,
              deleteDialogOpen: true,
            })
          }
          style={style}
        />
        <div style={styles.divider} />
      </div>
    ))
  }

  render() {
    const { gps, fields, formId, onChange, style } = this.props

    const { contactsCount } = this.state

    if (!gps || !fields.importantContacts) return null

    return (
      <div>
        <div style={style}>
          <GPForm
            fields={fields}
            formId={formId}
            onChange={onChange}
            gps={gps}
          />
        </div>
        {contactsCount === 0 ? (
          <div>
            <div style={style}>
              <div style={styles.footer}>
                <ButtonOLD
                  className="important-contact-add"
                  onClick={this.addContact}
                  style={styles.addButton}
                  icon={<Glyph name="plus" />}
                  type="primary"
                >
                  Add a new contact
                </ButtonOLD>
              </div>
            </div>
            <div style={styles.divider} />
          </div>
        ) : (
          <div>
            <div style={styles.divider} />
            {this.renderContacts(contactsCount)}
          </div>
        )}
        <ConfirmationDialog
          isOpen={this.state.deleteDialogOpen}
          onCancel={this.closeDeleteDialog}
          onConfirmation={this.deleteContact}
          confirmationType="warning"
        >
          {CONFIRMATION_BODY}
        </ConfirmationDialog>
      </div>
    )
  }
}

const CONFIRMATION_BODY = (
  <div>
    Are you sure want to delete this important contact?
    <br />
    <br />
    You will lose any information you have recorded about this particular
    contact.
  </div>
)

const styles = {
  divider: {
    borderBottom: '1px solid',
    borderColor: colors.grey,
    height: 1,
    margin: 'auto',
    marginTop: 20,
    marginBottom: 20,
    width: '90%',
    display: 'none',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 20,
  },
}
